import * as yup from "yup";

export const validationSchema = yup.object().shape({
  email: yup.string().email('Invalid Email').required("Email is required"),

  // namme :yup.string().name('Invalid Name').required('Name is required'),
  password: yup.string().required("Password is required"),
});
